import * as React from 'react';
import styled from '../../utils/styled';
import TextFieldInput from './private/TextFieldInput';
import TextFieldMultilineInput from './private/TextFieldMultilineInput';
import TextFieldIcon from './private/TextFieldIcon';
import {TextFieldProps} from './types';

const Root = styled('span')({
  display: 'inline-block',
  width: '100%',
  position: 'relative',
  verticalAlign: 'top'
});

// TODO: add docs, tests, success/error state, addons
export default class TextField extends React.Component<TextFieldProps, {}> {
  public static defaultProps = {
    iconPosition: 'start'
  };

  private _input: HTMLInputElement;

  public render() {
    const {icon, iconPosition, small, large, multiline} = this.props;

    const InputComponent = multiline ? TextFieldMultilineInput : TextFieldInput;

    return (
      <Root>
        <InputComponent {...this.props} innerRef={this._setInput} />

        {icon ? (
          <TextFieldIcon icon={icon} position={iconPosition!} small={Boolean(small)} large={Boolean(large)} />
        ) : null}
      </Root>
    );
  }

  public focus() {
    this._input.focus();
  }

  public blur() {
    this._input.blur();
  }

  private _setInput = (node: HTMLInputElement) => {
    this._input = node;

    if (typeof this.props.inputRef === 'function') {
      this.props.inputRef(node);
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/TextField/TextField.tsx